import { render, staticRenderFns } from "./forgetPinCode.vue?vue&type=template&id=288cc2bc&"
import script from "./forgetPinCode.vue?vue&type=script&lang=js&"
export * from "./forgetPinCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports